import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';


import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import Truncate from 'react-truncate';
import {
  rtlLanguages,
} from '../../helpers';
import format from '../../helpers/date';

import { WysiwygField } from '..';

import { FALLBACK_IMAGE_TEASER } from '../../config/constants';

const TYPE_ARTICLE = 'article';
const TYPE_STORY = 'story';

import './style.scss';

const Teaser = (props) => {
  const { t } = useTranslation();
  const { entity, type, large, labeled, showDate, lazyload } = props;

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const imageMedium = entity.getIn(
    ['field_media_item', 0, 'styles', 'teaser_image_large'],
    FALLBACK_IMAGE_TEASER
  );

  const date = new Date(entity.getIn(['field_publication_date', 0, 'value'], entity.getIn(['created', 0, 'value'])));
  const langcode = entity.getIn(['langcode', 0, 'value']);
  const url = entity.getIn(['paths', langcode]);
  const fullWidth = !large ? false : large;
  const readTimeInMinutes = entity.getIn(['node_read_time', 0, 'value'], null);
  const showReadTime = [TYPE_ARTICLE, TYPE_STORY].includes(type);

  const topClasses = c('Teaser', {
    'fullWidth': fullWidth,
    'Teaser--is-rtl': rtlLanguages.includes(langcode),
  });

  const headerClasses = c('Teaser__heading', {
    'Teaser__heading--no-image': !imageMedium,
  });

  return (
    <CoreLink to={url} className="Teaser__link">
      <div className={topClasses}>
        <div className={headerClasses}>
          <div className="Teaser__image">
            {imageMedium && (
              <>
                <Image src={imageMedium} lazyload={lazyload} />
                <div className="backdrop" />
                <div className="backdrop--hover" />
              </>
            )}
            <div className="image-placeholder" />
          </div>
          <div className="Teaser__heading__inner">
            {labeled !== false && (
              <div className="Teaser__heading__inner__type">
                <div>
                  {t(`entities.${type}`)}
                </div>
              </div>
            )}
            {showDate && (
              <div className="Teaser__heading__inner__date">
                <span>{format(date, 'd')}</span>
                <span>{format(date, 'MMM')}</span>
              </div>
            )}
          </div>
        </div>
        <div className="Teaser__content">
          <div className="Teaser__title">
            {fullWidth ? (<h2>{title}</h2>) : (<h4>{title}</h4>)}
          </div>
          <div className="Teaser__body">
            <Truncate lines={2} ellipsis="...">
              <WysiwygField
                property="schema:text"
                html={(summary !== '' ? summary : body)} />
            </Truncate>
          </div>
          {(showReadTime && parseInt(readTimeInMinutes) !== 0) && (
            <div className="Teaser__readtime">
              {t('general.read_time')}: {readTimeInMinutes} {t('general.minutes_short')}.
            </div>
          )}
        </div>
      </div>
    </CoreLink>
  );
};

export default Teaser;
